import type { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useState, type ReactNode } from "react";
import { createQueryClient } from "@/api/query-client";
import { AuthStatusProvider, type AuthStatus } from "@/auth/auth-status";
import { TooltipProvider } from "@/components/ui/primitives";
import { ThemeProvider } from "@/lib/theme";
import { createAppRouter } from "./router";

interface AppProps {
  msal: PublicClientApplication | null;
  authStatus: AuthStatus;
}

export function App({ msal, authStatus }: AppProps) {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => createAppRouter(queryClient));

  const tree: ReactNode = (
    <AuthStatusProvider value={authStatus}>
      <RouterProvider router={router} />
    </AuthStatusProvider>
  );

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={300}>{msal ? <MsalProvider instance={msal}>{tree}</MsalProvider> : tree}</TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
